export const checkForLink = (wordsToCheck, str) => {
  //   var words = ["http", ".com", ".org", ".xyz"];
  var words = wordsToCheck;
  var value = new RegExp(words.join("|")).test(str);
  return value;
};
